import { render, staticRenderFns } from "./role-set-menu.vue?vue&type=template&id=8f7b3998&"
import script from "./role-set-menu.vue?vue&type=script&lang=js&"
export * from "./role-set-menu.vue?vue&type=script&lang=js&"
import style0 from "./role-set-menu.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./role-set-menu.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports